module.exports = __webpack_public_path__ + "static/media/chevron-right.b2767bfe.webp";